/**
 * Strip de confiança + Legenda dos tipos de reserva.
 *
 * Esses dois pequenos componentes se encaixam ENTRE o hero e os carrosséis
 * para resolver duas dúvidas comuns do visitante:
 *  1. "Posso confiar?"      → TrustStrip
 *  2. "Por que tem 2 cores de botão?" → BookingTypeLegend
 */

export function TrustStrip() {
  return (
    <div className="trust-strip">
      <div className="trust-strip__item">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
        <div>
          <strong>Pagamento seguro</strong>
          <span>com retenção até a confirmação</span>
        </div>
      </div>
      <div className="trust-strip__item">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6 9 17l-5-5" />
        </svg>
        <div>
          <strong>Operadores verificados</strong>
          <span>todos com cadastro e seguro</span>
        </div>
      </div>
      <div className="trust-strip__item">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z" />
          <path d="M12 7v5l3 3" />
        </svg>
        <div>
          <strong>Cancele em até 24h</strong>
          <span>antes da experiência</span>
        </div>
      </div>
    </div>
  );
}

export function BookingTypeLegend() {
  return (
    <div className="booking-legend">
      <h4>Como funcionam as reservas</h4>
      <div className="booking-legend__row">
        <div className="booking-legend__item">
          <span className="booking-legend__dot booking-legend__dot--instant" aria-hidden="true" />
          <div>
            <strong>Confirmação Imediata</strong>
            <span>Pagou, reservado. Confirmação na hora.</span>
          </div>
        </div>
        <div className="booking-legend__item">
          <span className="booking-legend__dot booking-legend__dot--request" aria-hidden="true" />
          <div>
            <strong>Sob Consulta</strong>
            <span>Operador confirma em até 24h. Pagamento só após resposta.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
